import { useFilter } from "../../../../hooks/useFilter";
import "../styles.css"

export function InfoManagements() {
    const {
        snapshotMicroAreaMetrics
    } = useFilter();

    if (!snapshotMicroAreaMetrics) return <></>
    return (
        <section className="dashBoardInfo__container" style={{ marginTop: 25 }}>
            <div className="dashBoardInfo__owner--container">
                <small style={{ fontSize: 12, width: 150 }}>Média de <br />taxa de lotação</small>
                <h6 style={{ fontSize: 20 }}>{snapshotMicroAreaMetrics.total_average_instant_capacity_rate.toFixed(2)}</h6>
            </div>
            <div className="dashBoardInfo__owner--container">
                <small style={{ fontSize: 12, width: 150 }}>Média de altura</small>
                <h6 style={{ fontSize: 20, overflow: "visible" }}>{snapshotMicroAreaMetrics.total_monitoring_counts.height_count == 0 ? "-" : snapshotMicroAreaMetrics.total_average_height.toFixed(2)}</h6>
            </div>
            <div className="dashBoardInfo__owner--container">
                <small style={{ fontSize: 12, width: 150 }}>Média de nota</small>
                <h6 style={{ fontSize: 20 }}>{snapshotMicroAreaMetrics.total_monitoring_counts.rating_count == 0 ? "-" : snapshotMicroAreaMetrics.total_average_rating.toFixed(2)}</h6>
            </div>

            <div style={{ display: "flex", gap: 10 }}>
                <div className="dashBoardInfoSplited__owner--container">
                    <small>Coletas de altura</small>
                    <h6 style={{ fontSize: 20 }}>{snapshotMicroAreaMetrics.total_monitoring_counts.height_count}</h6>
                </div>
                <div className="dashBoardInfoSplited__owner--container">
                    <small>Coletas de nota</small>
                    <h6 style={{ fontSize: 20 }}>{snapshotMicroAreaMetrics.total_monitoring_counts.rating_count}</h6>
                </div>
            </div>
        </section>
    );
}